// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"352":"ec056473","396":"36feaad2","966":"b87333af"}[chunkId] + ".css";
};